// Error monitoring (Sentry) for the web app.
// Does nothing unless REACT_APP_SENTRY_DSN is set, so local runs and tests stay silent.
// The DSN is a setting, never written in code.
import * as Sentry from '@sentry/react';
import { scrubEvent } from './scrub';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    sendDefaultPii: false,        // never attach IP address, cookies, etc.
    beforeSend: scrubEvent,       // strip phones/emails from every error report
    beforeBreadcrumb: scrubEvent, // ...and from the trail of events leading up to it
  });
}

// Sends a screen crash (caught by the app's ErrorBoundary) to Sentry, together
// with the list of screen parts it happened in, so we can find and fix it.
// Does nothing when no DSN is set (local runs and tests). The report still
// passes through scrubEvent above, so no phones/emails/names in URLs leave.
export function reportRenderError(error, componentStack) {
  if (!process.env.REACT_APP_SENTRY_DSN) return false;
  Sentry.captureException(error, { contexts: { react: { componentStack } } });
  return true;
}
